import clsx from 'clsx'
import { categoryConfig } from './constants'

interface CategoryBadgeProps {
  category: string | null
  size?: 'sm' | 'md'
}

export function CategoryBadge({ category, size = 'md' }: CategoryBadgeProps) {
  const config = categoryConfig[category || 'Other'] || categoryConfig.Other
  return (
    <span
      className={clsx(
        'rounded-full font-mono flex-shrink-0',
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
        config.bgClass,
        config.textClass
      )}
    >
      {config.icon} {size === 'sm' ? '' : (category || 'Other')}
    </span>
  )
}

export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={clsx(
        'px-2 py-0.5 rounded-full text-xs font-mono flex items-center gap-1',
        status === 'completed' && 'bg-signal-green/20 text-signal-green',
        status === 'running' && 'bg-signal-blue/20 text-signal-blue',
        status === 'analyzing' && 'bg-signal-purple/20 text-signal-purple',
        status === 'pending' && 'bg-star-dim/20 text-star-dim',
        status === 'failed' && 'bg-signal-red/20 text-signal-red'
      )}
    >
      {(status === 'running' || status === 'analyzing' || status === 'pending') && (
        <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" />
      )}
      {status}
    </span>
  )
}
